import React from 'react';
import { HeroSection } from '../components/home/HeroSection';
import { StatsSection } from '../components/home/StatsSection';
import { FeaturedProjects } from '../components/home/FeaturedProjects';
import { LatestBids } from '../components/home/LatestBids';
import { ProcurementQuickLinks } from '../components/home/ProcurementQuickLinks';
import { NewsSection } from '../components/home/NewsSection';
import { CTASection } from '../components/home/CTASection';
export function Home() {
  return <div data-id="element-781" data-mp="24gikkbuzv8na">
      <HeroSection data-id="element-782" data-mp="24g8uko9y91hl" />
      <StatsSection data-id="element-783" data-mp="24htqah802qh1" />
      <FeaturedProjects data-id="element-784" data-mp="24haeli8y0ybg" />
      <LatestBids data-id="element-785" data-mp="29g504ryap0z9" />
      <ProcurementQuickLinks data-id="element-786" data-mp="29flqrzmpnkwu" />
      <NewsSection data-id="element-787" data-mp="29fbww0yjotlv" />
      <CTASection data-id="element-788" data-mp="29i7ybz9lq0f2" />
    </div>;
}